<div class="kr-comment-dialog__header" data-testid="comment_dialog_header">
  <h4
    class="kr-comment-dialog__header-text"
    data-testid="comment_dialog_title"
    [translate]="
      'transactions.commentDialog.title.' + (isEdit ? 'view' : 'add')
    "
    [translateParams]="{
      name: wallet ? wallet.name + ' /' : '',
    }"></h4>

  <button
    class="kr-comment-dialog__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    data-testid="comment_dialog_header_close_btn"
    [onlyIcon]="true"
    (click)="close()">
    <fu-icon
      iconName="close-square"
      data-testid="comment_dialog_close_icon"></fu-icon>
  </button>
</div>

<form
  class="kr-comment-dialog__body"
  [formGroup]="form"
  (ngSubmit)="save()"
  data-testid="comment_dialog_form">
  <fu-text-area
    formControlName="comment"
    [maxLength]="260"
    [rows]="4"
    data-testid="comment_dialog_comment_textarea"
    [label]="'transactions.commentDialog.comment.label' | translate">
  </fu-text-area>

  <div class="kr-actions" data-testid="comment_dialog_actions">
    <button
      type="button"
      fuButton
      size="m"
      uiType="secondary"
      data-testid="comment_dialog_footer_close_btn"
      (click)="close()"
      translate="transactions.commentDialog.btn.close"></button>

    @if (isEdit) {
      <button
        type="button"
        fuButton
        size="m"
        uiType="secondary"
        data-testid="comment_dialog_delete_btn"
        (click)="remove()"
        translate="transactions.commentDialog.btn.delete"></button>
    }

    <button
      type="submit"
      fuButton
      size="m"
      uiType="primary"
      data-testid="comment_dialog_submit_btn"
      [disabled]="!form.valid"
      [translate]="
        'transactions.commentDialog.btn.' + (isEdit ? 'update' : 'add')
      "></button>
  </div>
</form>
